import React from "react";
import SubTitle from "../title/sub-title";
import Banner from "../banner";
import unit1 from "../../../images/unit/zbdw01.png";
import unit2 from "../../../images/unit/zbdw02.png";
import unit3 from "../../../images/unit/cbdw01.png";
import unit4 from "../../../images/unit/cbdw02.png";
import unit5 from "../../../images/unit/hzdw01.png";
import unit6 from "../../../images/unit/hzdw02.png";
import unit7 from "../../../images/unit/hzdw03.png";

const ActivityOrg = () => {
  return (
    <>
	{/*	<Banner />*/}
      <div className="jury__line outlineTitle" style={{   textAlign: "center",  marginTop: '128px' }}>
        <label className={`enter_label  active `}  >主办单位</label>
      </div>
      <div className="home-row" style={{marginTop: "24px", justifyContent: "space-between"}}>
        <div className="home-v2-text"></div>
        <div className="home-v2-unitLogo"><img src={unit1} /></div>
        <div className="home-v2-unitLogo"><img src={unit2} /></div>
        <div className="home-v2-text"></div>
      </div>
      {/* <div className="home-row" style={{marginTop: "24px", justifyContent: "space-between"}}>
        <div className="home-v2-text"></div>
        <div className="home-v2-text">上海市知识产权局</div>
        <div className="home-v2-text">上海市科学技术委员会</div>
        <div className="home-v2-text"></div>
      </div> */}


      <div className="jury__line outlineTitle" style={{   textAlign: "center",  marginTop: '64px' }}>
        <label className={`enter_label  active `}  >承办单位</label>
      </div>
      <div className="home-row" style={{marginTop: "24px", justifyContent: "space-between"}}>
        <div className="home-v2-text"></div>
        <div className="home-v2-unitLogo"><img src={unit3} /></div>
        <div className="home-v2-unitLogo"><img src={unit4} /></div>
        <div className="home-v2-text"></div>
      </div>
      <div className="home-row" style={{marginTop: "24px", justifyContent: "space-between"}}>
        <div className="home-v2-text"></div>
        <div className="home-v2-text">上海技术交易所</div>
        <div className="home-v2-text">上海市高校科技发展中心</div>
        <div className="home-v2-text"></div>
      </div>

      <div className="jury__line outlineTitle" style={{   textAlign: "center",  marginTop: '64px' }}>
        <label className={`enter_label  active `}  >合作单位</label>
      </div>
      <div className="home-row" style={{marginTop: "24px", justifyContent: "space-between"}}>
        <div className="home-v2-unitLogo">
          <img src={unit5} />
        </div>
        <div className="home-v2-unitLogo">
          <img src={unit6} />
        </div>
        <div className="home-v2-unitLogo">
          <img src={unit7} />
        </div>
        {/* <div className="home-v2-unitLogo">
          <img src={unit4} />
        </div> */}
      </div>
      <div className="home-row" style={{marginTop: "24px",marginBottom: "48px", justifyContent: "space-between"}}>
        <div className="home-v2-text">国家技术转移东部中心</div>
        <div className="home-v2-text">上海环保科技园有限公司</div>
        <div className="home-v2-text">高校技术市场</div>
        {/* <div className="home-v2-text">上海市高校科技发展中心</div> */}
      </div>

    </>
  );
};

export default ActivityOrg;
